<template>
  <b-card title="ویرایش دسته">
    <b-form>
      <b-row>
        <b-col cols="6">
          <!-- category name-->
          <b-form-group
              label="نام دسته"
          >
            <b-form-input
                placeholder="نام دسته را وارد کنید"
                v-model="title"
            />
          </b-form-group>
          <!-- mother categories-->
          <b-form-group
              label="انتخاب دسته اصلی"
          >
            <b-form-select
                id="mother-categories"
                v-model="selectedCategory"
                :options="categories"
            />

          </b-form-group>

          <b-form-group
              label="انتخاب دسته برای"
              label-for="mother-categories"
          >
            <b-form-select
                id="type"
                v-model="selectedType"
                :options="categoryType"
            />

          </b-form-group>

          <b-form-group
              v-if="selectedType === 4"
              label="انتخاب تقویم"
              label-for="mother-categories"
          >
            <b-form-select
                id="type-calender"
                v-model="selectedCalenderType"
                :options="CategoryPregnancyCalendarType "
            />
          </b-form-group>


          <b-form-group
              v-if="selectedCategory == undefined"
              label=" انتخاب رنگ دسته اصلی از"
              label-for="mother-color"
          >

            <color-picker v-model="colorStart"></color-picker>

            <div class="selected-color-info">
              <p>رنگ انتخاب شده</p>
              <svg height="32" width="32">
                <circle cx="16" cy="16" r="15" :fill="colorStart" />
              </svg>
            </div>

            <p>
              Color:


              <b-form-input
                  id="v-color"
                  placeholder="کد رنگ را به صورت hex وارد کنید"
                  v-model="colorStart"
              />
            </p>
          </b-form-group>


          <b-form-group
              v-if="selectedCategory == undefined"
              label=" انتخاب رنگ دسته اصلی به"
              label-for="mother-color"
          >

            <color-picker v-model="colorEnd"></color-picker>

            <div class="selected-color-info">
              <p>رنگ انتخاب شده</p>
              <svg height="32" width="32">
                <circle cx="16" cy="16" r="15" :fill="colorEnd" />
              </svg>
            </div>

            <p>
              Color:


              <b-form-input
                  placeholder="کد رنگ را به صورت hex وارد کنید"
                  v-model="colorEnd"
              />
            </p>
          </b-form-group>





        </b-col>
        <b-col cols="6">
          <b-form-group
              label="ویرایش آیکون دسته"

          >
            <b-form-file
                v-model="file"
                placeholder="فایل خود را انتخاب کنید یا اینجا drop کنید"
                drop-placeholder="Drop file here..."
                accept=".jpg, .png,.svg"
                @change="handleImageUpload($event)"
            />
          </b-form-group>
          <div class="mt-2 image-preview">
            <b-img :src="imagePreView" v-show="showImagePreView" fluid/>
          </div>



          <video-edit-form-content  :content="dataForEdit" @videoFormSubmit="videoFormSubmit"
          ></video-edit-form-content>

        </b-col>

        <b-col cols="12">
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="mr-1"
              @click="editCategories"
              variant="primary"
          >
            ثبت
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton,
  BCol,
  BFormFile,
  BForm,
  BFormCheckbox,
  BImg,
  BFormSelect,
  BFormGroup,
  BCardTitle,
  BCardSubTitle,
  BCardText,
  BFormInput,
  BLink,
  BCard,
  BRow,
  BCardBody
} from 'bootstrap-vue'
import Croppa from 'vue-croppa'
import Vue from 'vue'
import categoryRepository from '@/modules/categories/services/categoryRepository'
import axios from '@/libs/axios'
import Swal from 'sweetalert2'
import { $themeConfig } from '@themeConfig'
import uploadService from '@/modules/services/uploadService'
import router from '@/router'
import videoFormComponent from "@/modules/contents/add/videoFormComponent";
import videoEditFormContent from "@/modules/contents/edit/videoEditFormContent";
import Ripple from "vue-ripple-directive";
import {$appConfig} from "../../../../appConfig";
import ColorPicker from 'vue-color-picker-wheel';

Vue.use(Croppa)
export default {
  name: 'editCategory',
  created() {
    this.categoryId = router.currentRoute.params.id
    this.getCategories()
    this.getCategoryById(this.categoryId)

  },
  components: {
    BCard,
    BFormSelect,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BCardBody,
    BCardSubTitle,
    BCardTitle,
    BCardText,
    BImg,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormFile,
    videoEditFormContent,
    ColorPicker

  },
  data() {
    return {


      colorStart: '#000000',
      colorEnd: '#000000',
      file:undefined,
      categoryId: '',
      imageFile: undefined,
      videoUrl:undefined,
      videoAddress:undefined,
      selectedCalenderType : undefined,
      color: undefined,
      dataForEdit: {},
      CategoryPregnancyCalendarType:[
        {
          value: 1,
          text: 'اطلاعات مادر'
        },
        {
          value: 2,
          text: 'اطلاعات نوزاد و فرزند'
        },
      ],
      categoryType: [
        {
          value: 1,
          text: ' محتوا'
        },
        {
          value: 2,
          text: 'گالری'
        },
        {
          value: 3,
          text: 'کتابخانه'
        },
        {
          value: 4,
          text: 'تقویم بارداری'
        }
      ],
      imagePreView: undefined,
      imageForEdit: undefined,
      showImagePreView: undefined,
      myCroppa: {},
      categories: [{
        value: undefined,
        text: 'دسته اصلی'
      }],
      selectedCategory: undefined,
      selectedType: undefined,
      imageUrl: undefined,
      title: ''
    }
  },

  methods: {
    handleImageUpload(event) {
      this.imageFile = event.target.files[0]

      console.log('handleCoverImageUpload')
      let reader = new FileReader()

      reader.addEventListener('load', function () {

        this.showImagePreView = true
        this.imagePreView = reader.result
        this.$emit('imageChanged', this.imageFile)

      }.bind(this), false)

      if (this.imageFile) {
        /*
          Ensure the file is an image file.
        */

        if (/\.(jpe?g|png)$/i.test(this.imageFile.name)) {

          /*
            Fire the readAsDataURL method which will read the file in and
            upon completion fire a 'load' event which we will listen to and
            display the image in the preview.
          */

          reader.readAsDataURL(this.imageFile)
        }
      }

    },
    async uploadCroppedImage() {
      if (this.imageFile) {
        console.log('upload image')
        this.imageUrl = await uploadService.upload(this.imageFile);
      }
    },
    onFileSizeExceed(file) {
      Swal.fire('خطا', 'لطفا عکسی با سایز کمتر از یک مگابایت استفاده کنید', 'error')
    },
    onImageTypeException(file) {
      Swal.fire('خطا', 'لطفا عکسی از نوع png , jpg , jpeg استفاده کنید', 'error')
    },
    async getCategories() {
      const { data } = await categoryRepository.get({})
      if (data.isSuccess) {
        let cats = data.data.data.map(p => {
          return {
            value: p.id,
            text: p.title,
          }
        })
        cats.forEach(p => {
          this.categories.push(p)
        })
      }
    },
    async getCategoryById(id) {
      const { data } = await categoryRepository.getById(`/${this.categoryId}?categoryID=${this.categoryId}`)
      console.log(data)

      if (data.isSuccess) {
        this.title = data.data.title
        this.selectedCategory = data.data.parent?.id
        this.selectedType = data.data.type
        this.showImagePreView = true
        this.imageForEdit = data.data.photo;
        this.imagePreView = $appConfig.endpoint.baseFileDomain + '/' +  data.data.photo
        this.videoAddress = data.data.video
        this.dataForEdit =  $appConfig.endpoint.baseFileDomain + '/' + this.videoAddress;
        this.colorEnd = data.data.colorEnd;
        this.colorStart = data.data.colorEnd;
        this.selectedCalenderType = data.data.calendarType;
      }
    },
    test() {
      this.uploadCroppedImage()
    },
    async editCategories(){
      if (this.title) {
        // await this.uploadCroppedImage()

        let intry = {
          parentID: this.selectedCategory,
          title: this.title,
          photo:this.imageForEdit,
          video : this.videoAddress,
          colorEnd:this.colorEnd,
          type:this.selectedType,
          colorStart:this.colorStart,
        }
        if (this.selectedType === 4) {

          if (!this.selectedCalenderType){
            await Swal.fire('خطا', ' نیاز است که فیلد نوع تقویم را پر کنید', 'error')
          }else {
            intry.calendarType = this.selectedCalenderType
          }

        }


        if(this.imageFile){
          await this.uploadCroppedImage()
          intry.photo = this.imageUrl;
        }

        const { data } = await categoryRepository.edit(`/${this.categoryId}` , intry)
        if (data.isSuccess) {
          await Swal.fire({
            confirmButtonText: 'ok',
            title: 'موفقیت',
            html: 'عملیات با موفقیت انجام شد',
            icon: 'success'
          })
          await this.$router.replace('/categories/list')
        } else {
          await Swal.fire('هشدار', data.message, 'warning')
        }
      } else {
        await Swal.fire('خطا', ' نیاز است که فیلد عنوان را پر کنید', 'error')

      }
    },
    videoFormSubmit(value) {
      console.log(value);
      // this.type = 'video';
      if (this.dataForEdit){
        this.videoAddress = value;
      }
      console.log(this.list);
    },
  },
  directives: {
    Ripple,
  },
}
</script>

<style scoped>


.croppa-container {
  background-color: #c3c3c3;
  border: 2px solid grey;
  border-radius: 8px;
}

.croppa-container:hover {
  opacity: 1;
  background-color: #8ac9ef;
}

.image-preview {
  max-width: 300px;
  max-height: 150px;
  alignment: center;
  margin-bottom: 3rem;
  border: #8afbff 1px solid;

}

#color-wheel {
  margin-left: auto;
  margin-right: auto;
}

.selected-color-info {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.selected-color-info p {
  margin: 0 5px 0 0;
}

</style>
